/**
Project: Voice Panel (c)
Title: Welcome 
Description: Component to verify the setup if regions are available to start the setup
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import React, { Component } from "react";
import { connect } from "react-redux";
import { Text, Button, Image } from "@fluentui/react-northstar";
import { Grid, Row, Col } from "react-flexbox-grid";
import PageUtil from "../../../../core/helpers/page-util";
import IntlUtil from "../../../../core/helpers/intl-util";
import VoiceCallingImage from "../../../../../assets/images/illustrations/voice_calling.png";
import {
  setVoiceSetupProgressAccountNumber,
  setVoiceSetupProgressPage,
} from "../actions/voice-setup-actions";
import { VoiceAdminConstants } from "../../common/settings/voice-admin-constants";
import TokenUtil from "../../../../core/helpers/token-util";

class Welcome extends Component {
  _isMounted = false;
  _intl_ns_vpa_voicesetup = "vpa_voicesetup";

  constructor(props) {
    super(props);
    this.state = { tokenData: TokenUtil.getIdentitySippioAccessTokenData() };
  }

  setStateAsync = (state) => {
    if (this._isMounted) {
      return new Promise((resolve) => {
        this.setState(state, resolve);
      });
    }
  };

  async componentDidMount() {
    this._isMounted = true;
    PageUtil.scrollToTop();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  loadNextPage = async () => {
    if (this.props.subscriberAccount?.accountNumber)
      this.props.setVoiceSetupProgressAccountNumber(
        this.props.subscriberAccount?.accountNumber
      );
    await this.props.setVoiceSetupProgressPage(
      VoiceAdminConstants.VOICE_SETUP.PROGRESS.PRESENCE
    );
  };

  render() {
    return (
      <>
        <Grid fluid className="page-grid p-t-25">
          <Row>
            <Col xs={12} sm={12} md={8} lg={9} className="m-b-20">
              {this.props.subscriberAccount &&
              this.props.subscriberAccount.accountNumber &&
              this.props.subscriberAccount.voiceSetupStatus === true ? (
                <>
                  <Row>
                    <Col xs={12} className="m-b-20">
                      <Text className="page-text">
                        {IntlUtil.getText(
                          this._intl_ns_vpa_voicesetup,
                          "content.voiceSetupCompleted"
                        )}{" "}
                        {this.props.subscriberAccount.accountNumber}
                      </Text>
                    </Col>
                  </Row>
                  {this.props.subscriberAccount &&
                  this.props.subscriberAccount.voiceRerunSetupPrivilege &&
                  this.props.subscriberAccount.voiceRerunSetupPrivilege ===
                    true ? (
                    <Row>
                      <Col xs={12} className="m-b-20">
                        <Button
                          primary
                          onClick={this.loadNextPage}
                          content={IntlUtil.getText(
                            this._intl_ns_vpa_voicesetup,
                            "content.rerunSetup"
                          )}
                          className="vpa-voice-setup-button"
                        />
                      </Col>
                    </Row>
                  ) : null}
                </>
              ) : this.state.tokenData?.userRole?.toLowerCase() !==
                VoiceAdminConstants.USER_ROLE.GLOBAL_ADMIN?.toLowerCase() ? (
                <>
                  <Row>
                    <Col xs={12} className="m-b-20">
                      <Text className="page-text">
                        {IntlUtil.getText(
                          this._intl_ns_vpa_voicesetup,
                          "notification.error.noPermission"
                        )}
                      </Text>
                    </Col>
                  </Row>
                </>
              ) : (
                <>
                  <Row>
                    <Col xs={12} className="m-b-20">
                      <Text className="page-heading6 text-fc-dark">
                        {IntlUtil.getText(
                          this._intl_ns_vpa_voicesetup,
                          "content.voiceSetupNotCompleted"
                        )}
                      </Text>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} className="m-b-20">
                      <Text className="page-text">
                        {IntlUtil.getText(
                          this._intl_ns_vpa_voicesetup,
                          "content.voiceSetupIntroduction"
                        )}
                      </Text>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} className="m-b-30">
                      <Text className="page-text">
                        {IntlUtil.getText(
                          this._intl_ns_vpa_voicesetup,
                          "content.voiceSetupBeginInfo"
                        )}
                      </Text>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} className="m-b-20">
                      <Button
                        primary
                        onClick={this.loadNextPage}
                        content={IntlUtil.getText(
                          this._intl_ns_vpa_voicesetup,
                          "content.beginSetup"
                        )}
                        className="vpa-voice-setup-button"
                      />
                    </Col>
                  </Row>
                </>
              )}
            </Col>
            <Col xs={12} sm={12} md={4} lg={3} className="m-b-20">
              <Image
                src={VoiceCallingImage}
                alt=""
                fluid
                className="vpa-setup-page-image"
              />
            </Col>
          </Row>
        </Grid>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  voiceSetupProgressPage: state.voiceSetupStore.voiceSetupProgressPage,
});

const mapActionToProps = {
  setVoiceSetupProgressPage,
  setVoiceSetupProgressAccountNumber,
};

export default connect(mapStateToProps, mapActionToProps)(Welcome);
